module.exports = __webpack_public_path__ + "static/about-b6d72dc46917197ce1f8ff478fd171e4.png";